import { siteSpecificRoutes, SKINCARE_PATH } from 'lib/constants/routes';

export type AvailableRouteNames = keyof typeof siteSpecificRoutes;

export const getSiteSpecificRoutes = (
  isSkincare: boolean,
  routeNames: AvailableRouteNames[],
) => {
  const matchingRoutes = routeNames.map((route) => siteSpecificRoutes[route]);

  if (isSkincare) {
    return matchingRoutes.map((route) => `${SKINCARE_PATH}${route}`);
  }

  return matchingRoutes;
};
